/**
 * Flow history — opens snapshots panel (list, capture, restore, delete)
 * For Media Devoted | Created By Ciro Autiero
 */

import { FC, useState } from 'react';
import { History } from 'lucide-react';
import type { TrackerId } from '@trafficpulse/shared';

import { Button } from '@/components/ui/layout/Button';

import SnapshotsPanel from './SnapshotsPanel';

export interface SnapshotsButtonProps {
  flowId: string;
  provider?: TrackerId;
  /** Called once a restore landed (e.g. to refetch the page's flow). */
  onRestored?: () => void;
}

const SnapshotsButton: FC<SnapshotsButtonProps> = ({
  flowId,
  provider,
  onRestored,
}) => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <Button
        type="button"
        variant="outline"
        size="sm"
        onClick={() => setOpen(true)}
        title="View saved flow versions, capture a backup, or restore"
      >
        <History className="h-3.5 w-3.5" aria-hidden />
        <span className="ml-1.5">Flow history</span>
      </Button>
      <SnapshotsPanel
        flowId={flowId}
        provider={provider}
        open={open}
        onOpenChange={setOpen}
        onRestored={onRestored}
      />
    </>
  );
};

export default SnapshotsButton;
